<app-page-panel >
  <ng-template #header>
    @for (stolcherInstance of stolcherInstances; track stolcherInstance) {
      <span class="minitoring-instance">
        <p-badge [value]=""
        [severity]="stolcherInstance.status === 'Online' ? 'success' : 'danger'" class="mr-2"></p-badge>
        <span>{{ stolcherInstance.monitoringName }}</span>
      </span>
    }
  </ng-template>

  <p-table [value]="services" class="p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th>Servizio</th>
        <th class="md:block hidden">Monitoraggio attivo</th>
        <th>Stato</th>
        <th class="md:block hidden">Ultimo aggiornamento</th>
        <th>Dettagli</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>

        <td class="">{{ service(item).monitoredServiceName }}</td>
        <td class="md:block hidden">
          <p-tag
            [severity]="service(item).activeMonitoring ? 'success' : 'danger'"
            [value]="service(item).activeMonitoring ? 'MONITORATO' : 'NON MONITORATO'"
          ></p-tag>
        </td>
        <td>
          <p-tag
            [severity]="serviceStatusSeverity(item)"
                        [value]="serviceStatus(item) === 'Online'
                            ? 'ATTIVO'
                            : (serviceStatus(item) === 'Offline'
                               ? 'ERRORE' : 'WARNING')"
          ></p-tag>
        </td>
        <td class="md:block hidden">
          <i class="fa fa-clock mr-2"></i>
          {{ serviceLastUpdate(item) | date:'dd MMMM yyyy H:mm' }}
        </td>
        <td>
          @if (serviceStatusNotes(item)) {
            <app-message
                [severity]="serviceStatusSeverityForMessage(item)"
            >{{ serviceStatusNotes(item) }}</app-message>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</app-page-panel>
